import { CATALOGUE_LABELS_FI } from '@omaplus/shared-messaging-catalogue';

import messages from './memberMessagingCatalogue.json' with { type: 'json' };

export const memberMessagingCatalogueFi = {
  ...CATALOGUE_LABELS_FI,
  ...messages,
} as const;
